const CATEGORY_TOOLTIP_HTML = '<div class="tooltip right">';
const LAZY_CATEGORY_TOOLTIP_HTML = '<div class="tooltip right" data-lazy-category-tooltip="1"></div>';

function extractCellsFromRowHtml(rowHtml) {
  if (typeof rowHtml !== "string" || rowHtml.length === 0) return [];
  const cells = [];
  const cellRegex = /<td\b([^>]*)>([\s\S]*?)<\/td>/g;
  let match = cellRegex.exec(rowHtml);
  while (match !== null) {
    const attrs = match[1] || "";
    const classMatch = attrs.match(/\bclass="([^"]*)"/);
    cells.push({
      className: classMatch?.[1] || "",
      html: match[2] || "",
    });
    match = cellRegex.exec(rowHtml);
  }
  return cells;
}

function trimContextCellHtml(cellHtml, prefix, activeContext) {
  if (!cellHtml || !activeContext) return cellHtml || "";

  const token = `<span class="${prefix}-`;
  let output = "";
  let cursor = 0;

  while (cursor < cellHtml.length) {
    const start = cellHtml.indexOf(token, cursor);
    if (start === -1) {
      output += cellHtml.slice(cursor);
      break;
    }

    output += cellHtml.slice(cursor, start);
    const classStart = start + token.length;
    const classEnd = cellHtml.indexOf('"', classStart);
    if (classEnd === -1) {
      output += cellHtml.slice(start);
      break;
    }

    const context = cellHtml.slice(classStart, classEnd).split(/\s+/)[0];
    const nextStart = cellHtml.indexOf(token, classEnd);
    const segmentEnd = nextStart === -1 ? cellHtml.length : nextStart;
    const segment = cellHtml.slice(start, segmentEnd);
    if (context === activeContext) output += segment;
    cursor = segmentEnd;
  }

  return output;
}

function trimCellHtmlToActiveContext(cell, activeContext) {
  const className = cell?.className || "";
  const html = cell?.html || "";
  if (className.includes("rank-cell")) return trimContextCellHtml(html, "r", activeContext);
  if (className.includes("change-cell")) return trimContextCellHtml(html, "c", activeContext);
  if (className.includes("trend-cell")) return trimContextCellHtml(html, "t", activeContext);
  return html;
}

export function stripCategoryTooltipHtml(cellHtml) {
  if (!cellHtml) return cellHtml || "";
  const tooltipStart = cellHtml.indexOf(CATEGORY_TOOLTIP_HTML);
  if (tooltipStart === -1) return cellHtml;
  const outerCloseStart = cellHtml.lastIndexOf("</div>");
  if (outerCloseStart <= tooltipStart) return cellHtml;
  return `${cellHtml.slice(0, tooltipStart)}${LAZY_CATEGORY_TOOLTIP_HTML}${cellHtml.slice(outerCloseStart)}`;
}

export function extractCategoryTooltipHtml(cellHtml) {
  if (!cellHtml) return "";
  const tooltipStart = cellHtml.indexOf(CATEGORY_TOOLTIP_HTML);
  if (tooltipStart === -1) return "";
  const outerCloseStart = cellHtml.lastIndexOf("</div>");
  if (outerCloseStart <= tooltipStart) return "";
  return cellHtml.slice(tooltipStart, outerCloseStart);
}

export function transformCellHtmlForClusterize(cell, activeContext, options = {}) {
  const className = cell?.className || "";
  let html = cell?.html || "";
  if (options.trimInactiveContexts) {
    html = trimCellHtmlToActiveContext(cell, activeContext);
  }
  if (options.lazyCategoryTooltip && className.includes("categories-cell")) {
    html = stripCategoryTooltipHtml(html);
  }
  return html;
}

export function transformRowHtmlForClusterize(row, activeContext, options = {}) {
  if (!row?.html) return row?.html || "";
  const cells = Array.isArray(row.cells) && row.cells.length > 0 ? row.cells : extractCellsFromRowHtml(row.html);
  if (cells.length === 0) return row.html;
  const trMatch = row.html.match(/^<tr\b([^>]*)>/);
  if (!trMatch) return row.html;
  const cellsHtml = cells
    .map((cell) => {
      const classAttr = cell.className ? ` class="${cell.className}"` : "";
      return `<td${classAttr}>${transformCellHtmlForClusterize(cell, activeContext, options)}</td>`;
    })
    .join("");
  return `<tr${trMatch[1]}>${cellsHtml}</tr>`;
}

export function trimRowHtmlToActiveContext(row, activeContext) {
  return transformRowHtmlForClusterize(row, activeContext, { trimInactiveContexts: true });
}
